import { IAdminDocument } from '../../components/admin/supervisors/interfaces';
import {
    AdminDocumentAction,
    AdminDocumentActionType,
} from '../actionTypes/adminDocument';

const adminSetupReducer = (
    state: Array<IAdminDocument> = [],
    action: AdminDocumentAction
) => {
    const newAdminDocument = action.payload as IAdminDocument;
    switch (action.type) {
        case AdminDocumentActionType.CREATE_ADMIN_DOCUMENT:
            return [...state, action.payload];
        case AdminDocumentActionType.DELETE_ADMIN_DOCUMENT:
            return state.filter(
                (item) => item._id !== action.payload['adminDocumentId']
            );
        case AdminDocumentActionType.UPDATE_ADMIN_DOCUMENT:
            return updateAdminDocument(state, newAdminDocument);
        case AdminDocumentActionType.GET_ADMIN_DOCUMENTS_BY_ROLE:
        case AdminDocumentActionType.GET_LAYER_ADMIN_DOCUMENTS:
        case AdminDocumentActionType.GET_ALL_ADMIN_DOCUMENTS:
            return action.payload as Array<IAdminDocument>;
        default:
            return state;
    }
};

export default adminSetupReducer;

const updateAdminDocument = (
    state: IAdminDocument[],
    newAdminDocument: IAdminDocument
) => {
    const indexOfUpdated = state.findIndex(
        (item) => item._id === newAdminDocument._id
    );
    state[indexOfUpdated] = newAdminDocument;
    return [...state];
};
